import React, { Component } from "react";
import { connect } from "react-redux";
import Dialog from "@material-ui/core/Dialog";
import { DialogTitle } from "../components/DialogTitle";
import { DialogContent } from "../components/DialogContent";
import Typography from "@material-ui/core/Typography";
import LinearProgress from "@material-ui/core/LinearProgress";
import { withStyles } from "@material-ui/core/styles";
import { formatBytes, formatSecondsToHMMSS } from "../utils/stringUtils";
import { ShowHide } from "../components/ShowHide";

const styles = theme => ({
  root: {
    bottom: theme.spacing(1)
  },
  content: {
    minHeight: "100px",
    textAlign: "center",
    margin: "100px"
  },
  left: {
    float: 'left'
  },
  right: {
    float: 'right'
  },
  bottom: {
    paddingTop: '40px',
    display: 'block'
  }
});

export class UploadingFilesProgress extends Component {
  minTimeLeft = Number.MAX_SAFE_INTEGER;
  getTimeLeftString(uploadEstimatedTimeLeft) {
    // Use the minTimeLeft we've calcualted to prevent time going all over the place.
    if (uploadEstimatedTimeLeft && uploadEstimatedTimeLeft !== Infinity) {
      this.minTimeLeft = Math.min(this.minTimeLeft, uploadEstimatedTimeLeft);
      return formatSecondsToHMMSS(this.minTimeLeft)
    }
    return "Calculating..."
  }

  render() {
    const { classes, title, uploadProgress, uploadNumFiles, uploadBytesTransferred, uploadSize, uploadEstimatedTimeLeft } = this.props;
    return (
      <Dialog
        maxWidth="sm"
        fullWidth={true}
        scroll="body"
        open
        spacing={0}
        className={classes.root}
      >
        <DialogTitle>{title}</DialogTitle>
        <DialogContent className={classes.content}>
          <Typography variant="subtitle2">
            <b>{uploadProgress < 100 ? (uploadNumFiles == 1 ? `Uploading File...` : `Uploading ${uploadNumFiles} Files...`) : "Processing..."}</b>
          </Typography>
          <LinearProgress
            variant={uploadProgress < 100 ? "determinate" : "indeterminate"}
            value={uploadProgress}
          />
          <ShowHide show={uploadEstimatedTimeLeft > 0}>
            <Typography variant="caption" className={classes.left}>
              {formatBytes(uploadBytesTransferred, 1)} / {formatBytes(uploadSize)}
            </Typography>
            <Typography variant="caption" className={classes.right}>
              Time left: {this.getTimeLeftString(uploadEstimatedTimeLeft)}
            </Typography>
          </ShowHide>
          <Typography variant="caption" className={classes.bottom}>
            Please wait for upload to complete before leaving this page.
          </Typography>
        </DialogContent>
      </Dialog>
    );
  }
}

const mapStateToProps = state => ({
  uploadProgress: state.ui.uploadProgress,
  uploadNumFiles: state.ui.uploadNumFiles,
  uploadBytesTransferred: state.ui.uploadBytesTransferred,
  uploadSize: state.ui.uploadSize,
  uploadEstimatedTimeLeft: state.ui.uploadEstimatedTimeLeft
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(UploadingFilesProgress));
